import { resetPassword } from '../../../api';
import { onRequest } from '../..';
import { debounce, getUrlParam, PropertyType, ActionsType } from '../../../common';

const resetSubmit = async (state: PropertyType, logout: () => void) => {
	const { password, repeatPassword, two_step_code } = state;
	const token = getUrlParam('token');
	const email = getUrlParam('email');
	const success = await resetPassword({
		token,
		email,
		password,
		repeatPassword,
		two_step_code,
	});

	debounce(() => logout(), 3000);
	return { errors: [], success };
};

export const actions: ActionsType = {
	PASS: (state, payload) => ({ password: payload }),
	PASS_FAIR: (state, payload) => ({ passwordFair: payload }),
	PASS_STRONG: (state, payload) => ({ passwordStrong: payload }),
	EMAIL: (state, payload) => ({ email: payload }),
	EMAIL_INVALID: (state, payload) => ({ emailInvalid: payload }),
	REPEAT_PASS: (state, payload) => ({ repeatPassword: payload }),
	REPEAT_INVALID: (state, payload) => ({ repeatInvalid: payload }),
	TWO_STEP_CODE: (state, payload) => ({ two_step_code: payload }),
	TWO_STEP: (state, payload) => ({ two_step_code: payload }),
	ERROR: (state, payload) => ({ errors: payload }),
	SUCCESS: (state, payload) => ({ success: payload }),
	RESET_SUBMIT: (state, payload) => onRequest(() => resetSubmit(state, payload)),
	MESSAGE_INVALIDATE: () => ({ errors: [], success: '' }),
};
